import React, { useEffect, useState, useMemo } from "react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import ic_filter from '../../assets/ic_filter.svg'
import '../../styles/_FirstTimeUsersVehicleCount.scss';

const FTUVehicleData = (props) => {

  const [rowData, setRowData] = useState([]);
  const [sortBy, setSortBy] = useState();

 
  useEffect(() => {
    const selectedProgramManager = props.selectedProgramManager?.value;
    const ftcCount = props.vehicleDeviceCombinationFilterData?.FTC_Count || 0;
    const vehicleData = props.vehicleDeviceCombinationFilterData?.vehicle_data || [];
  
    // if (!selectedProgramManager || vehicleData.length === 0) return;
    if (!selectedProgramManager || vehicleData.length === 0) {
      setRowData([]);
      return;
    }
  
    const isAsc = true; 
    const field = "typeOfVehicle"; 
  
    // Grouped structure
    const groupedMap = new Map();
  
    // Only one Program Manager in this case
    if (!groupedMap.has(selectedProgramManager)) {
      groupedMap.set(selectedProgramManager, {
        programManager: selectedProgramManager,
        ftc: ftcCount,
        partners: [],
        totalResources: 0, 
        totalVehicles: 0
      });
    }
  
    const pmGroup = groupedMap.get(selectedProgramManager);
  
    // Convert vehicleData to vehicleBreakdownArray
    const vehicleBreakdownArray = vehicleData.map(item => ({
      type: item.vehicle_type,
      count: item.user_count
    }));
  
    // Sort the vehicle breakdown if needed
    vehicleBreakdownArray.sort((a, b) =>
      isAsc
        ? (Number(a.count) || 0) - (Number(b.count) || 0)
        : (Number(b.count) || 0) - (Number(a.count) || 0)
    );
  
    pmGroup.totalVehicles = vehicleBreakdownArray.reduce((sum, item) => sum + (Number(item.count) || 0), 0);
  
    pmGroup.partners.push({
      partner: "-", 
      vehicleBreakdown: vehicleBreakdownArray,
      resources: []
    });
  
    const finalGroupedData = Array.from(groupedMap.values());
    if(vehicleData.length === 0){
      setRowData([]);
    }else{
    setRowData(finalGroupedData);
    }

  }, [props.vehicleDeviceCombinationFilterData, props.selectedProgramManager]);

  




 
  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);

 
  const sortVehicleData = (data, direction = "asc", selectedProgramManager, ftcCount) => {
    if (!Array.isArray(data) || data.length === 0) return [];
  
    const isAsc = direction === "asc";
  
    const sortedData = data.map(pm => {
      const updatedPartners = pm.partners.map(partner => {
        const sortedVehicleBreakdown = [...(partner.vehicleBreakdown || [])].sort((a, b) => {
          const aCount = Number(a.count) || 0;
          const bCount = Number(b.count) || 0;
          return isAsc ? aCount - bCount : bCount - aCount;
        });
  
        return {
          ...partner,
          vehicleBreakdown: sortedVehicleBreakdown
        };
      });
  
      return {
        ...pm,
        programManager: selectedProgramManager || pm.programManager,
        ftc: ftcCount ?? pm.ftc,
        partners: updatedPartners
      };
    });
  
    return sortedData;
  };
  
  
  

  useEffect(() => {
    if(rowData && rowData.length>0){
      const ftcCount =
      props.vehicleDeviceCombination?.FTC_Count ||
      props.vehicleDeviceCombinationFilterData?.FTC_Count ||
      0;
  
    if (rowData && rowData.length > 0 && props.selectedProgramManager) {
      const sortedData = sortVehicleData(
        rowData,
        sortBy,
        props.selectedProgramManager?.value,
        ftcCount
      );
  
      setRowData(sortedData);
    }
    }
  }, [sortBy]);
  

  const overlayNoRowsTemplate = rowData?.length === 1 && rowData[0].sEntryPoint === "No Data Available"
    ? '<span class="ag-overlay-no-rows-center">No data available</span>'
    : '<span class="ag-overlay-no-rows-center">loading...</span>';

  
  return (
<div className="first-time-users-vehicle-count">
<div className="header-section">
  <h3 className="spled-colored-label">First time Users based on Vehicle Count</h3>
  <div className="sort-by-section">
    <label>Sort By:</label>
    <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
      <option value="">-- Select --</option>
      <option value="asc">Count(Low to High)</option>
      <option value="desc">Count(High to Low)</option>
    </select>
  </div>
</div>

<div className="table-container">
  {/* Table Header */}
  <div className="table-header-wrapper">
    <table className="table-header">
      <thead>
        <tr>
          <th className="pm-col">Program Manager</th>
          <th className="ftc-col">FTCs</th>
          <th className="vehicle-col">
            Vehicle
            <img
              alt="Filter"
              src={ic_filter}
              height="20px"
              width="20px"
              onClick={() => props.handleVehicleDeviceFilterOpen()}
            />
          </th>
          <th className="count-col">Count</th>
        </tr>
      </thead>
    </table>
  </div>

  {/* Scrollable Body */}
  <div className="table-body-scrollable">
    <table className="table-body">
      <tbody>
        {rowData.length > 0 ? (
          rowData.map((pm, pmIndex) => {
            const totalVehicleRows = pm.partners.reduce(
              (acc, partner) => acc + (partner.vehicleBreakdown?.length || 0),
              0
            );

            return pm.partners.map((partner, partnerIndex) =>
              partner.vehicleBreakdown.map((vehicle, vehicleIndex) => {
                const isFirstVehicleForPM = partnerIndex === 0 && vehicleIndex === 0;
                const isFirstVehicleForPartner = vehicleIndex === 0;

                return (
                  <tr key={`${pmIndex}-${partnerIndex}-${vehicleIndex}`}>
                    {isFirstVehicleForPM && (
                      <td rowSpan={totalVehicleRows} className="pm-cell">
                        {pm.programManager}
                      </td>
                    )}
                    {isFirstVehicleForPartner && (
                      <td rowSpan={partner.vehicleBreakdown.length} className="ftc-cell">
                        {pm.ftc}
                      </td>
                    )}
                    <td className="vehicle-cell">{vehicle.type}</td>
                    <td className="count-cell">{vehicle.count}</td>
                  </tr>
                );
              })
            );
          })
        ) : (
          <tr className="no-data-row">
            <td colSpan={4}>No data available</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>

  {/* Footer Row */}
  <div className="table-footer-wrapper">
    <table className="table-footer">
      <tfoot>
        <tr>
          <td className="pm-col-footer"></td>
          <td className="ftc-col-footer"></td>
          <td className="vehicle-col-footer"></td>
          <td className="total-cell-footer">
            Total:{' '}
            {(props.vehicleDeviceCombinationFilterData?.vehicle_data?.reduce((total, row) => total + row.user_count, 0) || 0)}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
</div>
  )
}

export default FTUVehicleData
